import { PlusIcon } from "@heroicons/react/24/outline";
import { useNavigate } from "@tanstack/react-router";
import { t } from "i18next";
import type { JSX } from "react";
import { cn } from "@/lib/utils";
import { SubscriptionOnlyButton } from "../SubscriptionOnlyButton/SubscriptionOnlyButton";
import { underV3 } from "../v3/flagged";

export const TemplatesEmpty = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-full">
      <div className="flex flex-col items-center justify-center gap-4">
        <p
          className={cn(
            "text-primary-dark",
            underV3("font-v3 text-[15px] text-v3-text-2"),
          )}
        >
          {t("templates.emptyStateCTA")}
        </p>
        <SubscriptionOnlyButton
          className="mt-4"
          onClick={async () => {
            await navigate({ to: "/template/new" });
          }}
        >
          <PlusIcon className="w-5 h-5" />
          {t("templates.newTemplateButton")}
        </SubscriptionOnlyButton>
      </div>
    </div>
  );
};
